import * as React from 'react'
import { Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { DownTime } from '../../model/DownTime'
import { FaExclamation } from 'react-icons/fa'

type Props = {
  onSaveClick(downtime: DownTime): void
  onCancelClick(): void
  editableManualDowntime: DownTime
}

export class NewEventDropDown extends React.Component<Props> {
  onSaveClick(): void {
    if (this.props.editableManualDowntime.IsValid())
      this.props.onSaveClick(this.props.editableManualDowntime)
  }

  onCancelClick(): void {
    this.props.onCancelClick()
  }

  renderNewEventDropDown = (): JSX.Element => {
    return (
      <Dropdown id="new-downtime-options">
        <Dropdown.Toggle
          id="new-downtime-options-toggle"
          variant={this.props.editableManualDowntime.failedAction ? 'danger' : 'primary'}
        >
          {this.props.editableManualDowntime.failedAction && <FaExclamation />}
        </Dropdown.Toggle>
        <Dropdown.Menu className="new-downtime-dropdown-menu-right">
          <Dropdown.Item
            key="save"
            disabled={!this.props.editableManualDowntime.IsValid()}
            onClick={() => this.onSaveClick()}
          >
            Save
          </Dropdown.Item>
          <Dropdown.Item key="cancel" onClick={() => this.onCancelClick()}>
            Cancel
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    )
  }

  render(): JSX.Element {
    if (this.props.editableManualDowntime.failedAction) {
      return (
        <OverlayTrigger
          placement={'left'}
          overlay={
            <Tooltip id={'failed-manual-downtime-save-tooltip'}>
              <strong>Save failed</strong>
              <br />
              Try saving again
            </Tooltip>
          }
        >
          {this.renderNewEventDropDown()}
        </OverlayTrigger>
      )
    } else {
      return this.renderNewEventDropDown()
    }
  }
}

export default NewEventDropDown
